import Head from 'next/head'
import Image from 'next/image'

import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

import useAppQueryState from '@hooks/useAppQueryState'

import aliDouglas from '@images/ali-douglas-ceo.png'

import { quotes } from './lib/quotes'

const ExpertSection = () => {
    const { appQueryState } = useAppQueryState()
    const category = appQueryState.categoryId!

    const quote = quotes[category]

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'CreativeWork',
                            name: 'Our expert says',
                            text: quote.join(' '),
                            author: {
                                '@type': 'Person',
                                jobTitle: 'CEO',
                                name: 'Alastair Douglas',
                            },
                        }),
                    }}
                />
            </Head>

            <Stack
                direction={['column', 'row']}
                gridColumn={['1/13', '1/13', '2/12']}
                alignItems={['flex-start', 'center']}
                space="space20"
            >
                <Image
                    src={aliDouglas}
                    alt="Alastair Douglas - CEO of TotallyMoney"
                    width={180}
                    priority={false}
                    placeholder="empty"
                    sizes="(max-width: 768px) 83px, 180px"
                    quality={60}
                />

                <Stack space="space20">
                    <Heading variant="80">Our expert says</Heading>

                    <Stack space="space20">
                        {quote?.map((paragraph, i) => (
                            <Text
                                key={`${paragraph}-${i}`}
                                variant="120"
                                color="light"
                            >
                                “{paragraph}”
                            </Text>
                        ))}
                    </Stack>

                    <Text variant="100" weight="bold">
                        Alastair Douglas, CEO of TotallyMoney
                    </Text>
                </Stack>
            </Stack>
        </>
    )
}

export default ExpertSection
